// REA-CI/screens/legal/PrivacyPolicy.tsx


import React from 'react';
import { View, Text, ScrollView, StyleSheet } from 'react-native';

const PrivacyPolicy = () => (
  <ScrollView style={styles.container}>
    <Text style={styles.header}>Privacy Policy</Text>
    <Text style={styles.body}>
      At REA, we value your privacy and are committed to protecting your personal data. This Privacy Policy explains how we collect, use, and safeguard your information when you use our platform, REA CI, accessible at www.rea.mobi.
    </Text>

    <Text style={styles.subheader}>1. Information We Collect</Text>
    <Text style={styles.body}>
      We collect information to provide better services to our users:
      {"\n"}- Personal Information: Name, email, phone number, and government ID (for seller verification).
      {"\n"}- Usage Information: Interaction with the app, search history, and preferences.
      {"\n"}- Location Data: To display nearby properties and enhance your experience.
    </Text>

    <Text style={styles.subheader}>2. How We Use Your Information</Text>
    <Text style={styles.body}>
      We use the information to:
      {"\n"}- Connect buyers and sellers in the real estate market.
      {"\n"}- Provide personalized recommendations and search results.
      {"\n"}- Ensure security and verify seller identities.
    </Text>

    <Text style={styles.subheader}>3. Data Sharing</Text>
    <Text style={styles.body}>
      We do not sell your personal data. However, we may share your information with:
      {"\n"}- Trusted third-party partners to improve our services.
      {"\n"}- Authorities when required by law.
    </Text>

    <Text style={styles.subheader}>4. Your Rights</Text>
    <Text style={styles.body}>
      You have the right to access, update, or delete your personal information. Contact us at privacy@rea.mobi for assistance.
    </Text>

    <Text style={styles.body}>
      By using REA, you agree to this Privacy Policy. We may update this policy periodically.
    </Text>
  </ScrollView>
);

const styles = StyleSheet.create({
  container: { padding: 20 },
  header: { fontSize: 24, fontWeight: 'bold', marginBottom: 10 },
  subheader: { fontSize: 18, fontWeight: '600', marginTop: 15 },
  body: { fontSize: 14, marginTop: 5, lineHeight: 20 },
});

export default PrivacyPolicy;
